import { useId, type HTMLAttributes, type ReactNode } from 'react';
import styles from './Card.module.css';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  title?: string;
  actions?: ReactNode;
  titleSize?: 'sm' | 'lg';
};

export const Card = ({ title, actions, titleSize = 'sm', children, className, ...rest }: CardProps) => {
  const titleId = useId();
  return (
    <section
      className={[styles['card'], className ?? ''].join(' ')}
      aria-labelledby={title ? titleId : undefined}
      {...rest}
    >
      {title || actions ? (
        <header className={styles['header']}>
          {title ? (
            <h3
              id={titleId}
              className={[styles['title'], titleSize === 'lg' ? styles['large'] : ''].join(' ')}
            >
              {title}
            </h3>
          ) : (
            <span />
          )}
          {actions}
        </header>
      ) : null}
      {children}
    </section>
  );
};
